import { useTranslation } from 'react-i18next'
import React from 'react'
import styles from './ResAndDoc.module.scss'
import pen from 'assets/icons/pencil.svg'
import download from 'assets/icons/download.svg'
const TaskDocuments = ({ data, setOpenModal, status, role }) => {
  const { t } = useTranslation('common')

  const downloadFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h4>{t('archive.case_documents_short')}</h4>
        <div style={{ display: 'flex', gap: '15px' }}>
          {status === 'Завершен' ? (
            ''
          ) : (
            <button style={{ display: 'flex', background: '#736ced', alignItems:'center' }}>
              <img src={pen} alt="" style={{filter:"invert(1)"}} />{' '}
              <p
                style={{  paddingLeft: '4px' }}
                onClick={() => setOpenModal(true)}
              >
                Добавить{' '}
              </p>
            </button>
          )}
        </div>
      </div>
      <div
        className={styles.body}
        style={{ maxHeight: '350px', overflowY: 'auto' }}
      >
        <table className={styles.table__wrapper_left}>
          
          <tbody className={styles.table__body_left}>
            {data?.map((item) => {
              const fileUrlParts = item.file.split('/')
              const fileName = decodeURIComponent(
                fileUrlParts[fileUrlParts.length - 1],
              )

              return (
                <tr className={styles.table__row_left} key={item.file}>
                   <td
                    className={styles.table__item_left}
                    style={{ textAlign: 'left' }}
                  >
                    <span className={styles.table__title_left}>
                      <a href={item.file} download  target="_blank">
                        {' '}
                        <img className={styles.size} src={download} alt=""  />
                      </a>
                    </span>
                  </td>
                  <td className={styles.table__item_left}>
                    <span className={styles.table__title_left}>{fileName}</span>
                  </td>
                 
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TaskDocuments
